<template>
  <div :class="`${baseClass}__item ${baseClass}__item--large`">
    <h2 :class="`${baseClass}__title--large`">
      Subscribe to get full access to the world's best
      {{ docTypeLabel }} summaries!
    </h2>
    <router-link
      :to="{ name: 'billing' }"
      :class="`${baseClass}__btn--large btns btns--largest`"
    >
      Start Your Free Trial
    </router-link>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  baseClass: string
  docTypeLabel: string
}>()
</script>
